import { render, staticRenderFns } from "./StudioCalendar.vue?vue&type=template&id=3d25da03&scoped=true&"
import script from "./StudioCalendar.vue?vue&type=script&lang=js&"
export * from "./StudioCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d25da03",
  null
  
)

export default component.exports